<template>
  <ConfirmationModal>
    <template #title>
      <img width="50" height="50" src="@front/common/assets/Billet_2.svg" />

      <Typography :variant="TYPOGRAPHY_TYPES.h5" tag="h5" :class="$style.title">
        {{ $i18n('Validation de votre moyen de paiement') }}
      </Typography>
    </template>

    <Typography>
      {{
        $i18n(
          'Avant de continuer, pourriez-vous vérifier si votre carte de crédit actuelle est toujours valide ?',
        )
      }}
    </Typography>

    <CardBlock :class="$style.cardBlock" />

    <Divider :class="$style.divider" />

    <template #buttons="{ confirm, cancel }">
      <Button appearance="link" @click="cancel">
        {{ $i18n('Annuler') }}
      </Button>

      <Button :disabled="isPaypal" @click="confirm">
        {{ $i18n('Valider') }}
      </Button>
    </template>
  </ConfirmationModal>
</template>

<script>
import { ConfirmationModal } from '@front/common/components'
import { isObjectEmpty } from '@front/common/utils'
import { Button, Divider, Typography, TYPOGRAPHY_TYPES } from '@front/ui'
import { defineComponent, ref, watch } from '@vue/composition-api'

import CardBlock from '@member-area/components/CardBlock.vue'
import usePaymentMethod from '@member-area/core/resources/PaymentMethod/PaymentMethod.hook'

export default defineComponent({
  components: { ConfirmationModal, CardBlock, Divider, Typography, Button },
  setup() {
    const { fetchPaymentMethod, paymentMethod } = usePaymentMethod()
    const isPaypal = ref(false)

    fetchPaymentMethod()

    watch(
      paymentMethod,
      (value) => {
        isPaypal.value =
          Boolean(isObjectEmpty(value)) || value.provider === 'paypal'
      },
      { immediate: true },
    )

    return { TYPOGRAPHY_TYPES, isPaypal }
  },
})
</script>

<style lang="scss" module>
.title {
  margin-top: $ds-spacing-md;
  margin-bottom: $ds-spacing-xs;
}

.cardBlock {
  width: 100%;
  margin: $ds-spacing-md 0px;
}

.divider {
  margin-bottom: 0px;
}
</style>
